import { Component, OnDestroy } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { LoginModel } from "src/app/models/login.model";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-action-detail-button",
  templateUrl: "./action-detail-button.component.html",
  styleUrls: ["./action-detail-button.component.scss"],
})
export class ActionDetailButtonComponent implements OnDestroy {
  params: any;
  userInfo:LoginModel;
  private destroy$ = new Subject<void>();
  constructor(private authService:AuthService) {
    this.authService.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => (this.userInfo = res));
  }

  agInit(params: any): void {
    this.params = params;
  }

  action() {
    this.params.action(this.params.data);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  assignTo3Pl(value,params){
    const output = {
      value: value,
      node: params.node.data
    }
    this.params.callbackFunction(output);
  }
}
